import React from "react";
import { Link } from "react-router-dom";

const Swap = () => (
  <>
    <div className="dashboard_right">
      <div className="swap_outer_section">
        <h3>Quick Swap</h3>
        <div className="d-flex cnt_amountsl ">
          <ul className="swaplist">
            <li>
              <span>Minimum Amount | Maximum Amount</span>
              1 | 500 USDT
            </li>
            <li>
              <span>Swapping Fee</span>
              0.15%
            </li>
          </ul>
          <div className="swap_bitcoin">
            <img src="/images/bitcoinswap.svg" className="img-fluid" alt="swapbitcoin" />
          </div>
        </div>

        <div className="swap_usdtdata">
          <div className="d-flex">
            <div className="swap_ustd_bl">
              <div className="from">
                <p>From<i className="ri-information-line"></i></p>
                <p>
                  Available 12,450.5000 USDT
                  <Link to="/asset_managemnet/deposit" style={{ color: "#f3bb2c" }}>
                    <i className="ri-add-circle-fill"></i>
                  </Link>
                  <Link to="/user_profile/asset_overview" style={{ color: "#f3bb2c" }}>
                    <i className="ri-exchange-line"></i>
                  </Link>
                </p>
              </div>
              <div className="from">
                <button type="button" data-bs-toggle="modal" data-bs-target="#search_coin">
                  <img
                    src="/images/tether_icon.png"
                    className="img-fluid"
                    alt="USDT"
                  />
                  USDT
                  <i className="ri-arrow-drop-down-fill"></i>
                </button>
                <input
                  type="text"
                  inputMode="decimal"
                  name="fromSwap"
                  defaultValue="1000"
                  placeholder={`0`}
                  style={{
                    
                    background: "transparent",
                    border: "none",
                    textAlign: "right",
                    fontSize: "18px",
                    fontWeight: "600",
                    width: "100%",
                    outline: "none"
                  }}
                />
              </div>
            </div>

            <div className="swap_ustd_bl">
              <div className="from">
                <p>To<i className="ri-information-line"></i></p>
                <p>
                  Available 0.4521 BTC
                </p>
              </div>
              <div className="from">
                <button type="button" data-bs-toggle="modal" data-bs-target="#search_coin">
                  <img
                    src="/images/bitcoin_icon.png"
                    className="img-fluid"
                    alt="BTC"
                  />
                  BTC
                  <i className="ri-arrow-drop-down-fill"></i>
                </button>
                <input
                  type="text"
                  inputMode="decimal"
                  name="toSwap"
                  defaultValue="0.0152"
                  placeholder="0"
                  style={{
                   
                    background: "transparent",
                    border: "none",
                    textAlign: "right",
                    fontSize: "18px",
                    fontWeight: "600",
                    width: "100%",
                    outline: "none"
                  }}
                />
              </div>
            </div>

            <div className="vector_icon" style={{ cursor: "pointer" }}>
              <img src="/images/wallet_icon2.png" alt="wallet" />
            </div>
          </div>

          <p>
            <span>Conversion Rate (Approx.)</span>
            {" "}1 USDT ≈ 0.0000152 BTC
          </p>

          <button type="button" className="btn" data-bs-toggle="modal" data-bs-target="#more_details">
            Swap Now
          </button>
        </div>
      </div>

      <div className="dashboard_recent_s swap_tb_his">
        <div className="user_list_top">
          <div className="d-flex-between  mb-3  custom_dlflex">
            <h4>Recent Transactions  <small><Link to="/convert_history" className="mx-2 text-white"><small>View All<i className="ri-arrow-right-line"></i></small></Link></small></h4>

            <div className="searchBar custom-tabs">
              <i className="ri-search-2-line"></i>
              <input
                type="search"
                className="custom_search"
                placeholder="Search Crypto"
                defaultValue=""
              />
            </div>
          </div>
        </div>
        <div className="desktop_view2">
          <div className="table-responsive">
            <table>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Date</th>
                  <th>Swapping Currencies</th>
                  <th>Pay Amount</th>
                  <th>Get Amount</th>
                  <th>Swapping Fee</th>
                  <th>Conversion Rate</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>2026-04-08 02:30 PM</td>
                  <td>USDT <i className="ri-arrow-right-double-line"></i> BTC</td>
                  <td>1000.00000000 USDT</td>
                  <td>0.01520000 BTC</td>
                  <td>0.50000000 USDT</td>
                  <td>1 USDT =&gt; 0.00001520000 BTC</td>
                  <td className="text-success">Completed</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>2026-04-05 11:12 AM</td>
                  <td>BTC <i className="ri-arrow-right-double-line"></i> ETH</td>
                  <td>0.05000000 BTC</td>
                  <td>1.42000000 ETH</td>
                  <td>0.00007500 BTC</td>
                  <td>1 BTC =&gt; 28.40000000 ETH</td>
                  <td className="text-success">Completed</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>2026-04-01 09:45 PM</td>
                  <td>ETH <i className="ri-arrow-right-double-line"></i> USDT</td>
                  <td>2.00000000 ETH</td>
                  <td>6420.00000000 USDT</td>
                  <td>0.00300000 ETH</td>
                  <td>1 ETH =&gt; 3210.00000000 USDT</td>
                  <td className="text-success">Completed</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="mobile_view">
          <div className="table-responsive">
            <table>
              <thead>
                <tr>
                  <th>Swapping Currencies</th>
                  <th>Pay Amount</th>
                  <th>Get Amount/Fee</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>USDT <i className="ri-arrow-right-double-line"></i> BTC</td>
                  <td>1000.00000000 USDT</td>
                  <td>0.01520000 BTC<br />0.00000228 BTC</td>
                </tr>
                <tr>
                  <td>BTC <i className="ri-arrow-right-double-line"></i> ETH</td>
                  <td>0.05000000 BTC</td>
                  <td>1.42000000 ETH<br />0.00021300 ETH</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div
      className="modal fade search_form search_form_modal_2 search_coin"
      id="search_coin"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h4>Select Crypto</h4>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>

          <div className="modal-body">
            <form>
              <input
                type="text"
                className="searchfield"
                placeholder="Search coin name"
                defaultValue=""
              />
            </form>

            <div className="hot_trading_t">
              <div className="table-responsive">
                <table>
                  <tbody>
                    <tr className="swap-select-crypto-row selected">
                      <td>
                        <div className="td_first">
                          <div className="icon">
                            <img
                              src="/images/tether_icon.png"
                              alt="USDT"
                              width="30"
                            />
                          </div>
                          <div className="price_heading">
                            USDT
                            <span>/Tether</span>
                          </div>
                        </div>
                      </td>
                      <td className="right_t price_tb">
                        12450.5000
                      </td>
                    </tr>
                    <tr className="swap-select-crypto-row">
                      <td>
                        <div className="td_first">
                          <div className="icon">
                            <img
                              src="/images/bitcoin_icon.png"
                              alt="BTC"
                              width="30"
                            />
                          </div>
                          <div className="price_heading">
                            BTC
                            <span>/Bitcoin</span>
                          </div>
                        </div>
                      </td>
                      <td className="right_t price_tb">
                        0.4521
                      </td>
                    </tr>
                    <tr className="swap-select-crypto-row">
                      <td>
                        <div className="td_first">
                          <div className="icon">
                            <img
                              src="/images/eth_currency_img.svg"
                              alt="ETH"
                              width="30"
                            />
                          </div>
                          <div className="price_heading">
                            ETH
                            <span>/Ethereum</span>
                          </div>
                        </div>
                      </td>
                      <td className="right_t price_tb">
                        3.2100
                      </td>
                    </tr>
                    <tr className="swap-select-crypto-row">
                      <td>
                        <div className="td_first">
                          <div className="icon">
                            <img
                              src="/images/tether_icon.png"
                              alt="BNB"
                              width="30"
                            />
                          </div>
                          <div className="price_heading">
                            BNB
                            <span>/Binance Coin</span>
                          </div>
                        </div>
                      </td>
                      <td className="right_t price_tb">
                        0.0000
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="modal fade search_form search_coin" id="more_details" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5>Order details</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body modal-swap ">
            <div className="hot_trading_t model_height">
              <table>
                <tbody>
                  <tr>
                    <td>Swapping</td>
                    <td className="right_t price_tb">
                      1000 USDT
                      <i className="ri-arrow-right-double-line"></i>
                      0.0152 BTC
                    </td>
                  </tr>
                  <tr>
                    <td>Swapping Fee (0.15%)</td>
                    <td className="right_t price_tb">
                      0.0000228 BTC
                    </td>
                  </tr>
                  <tr>
                    <td>Deductable Amount</td>
                    <td className="right_t price_tb">
                      1000 USDT
                    </td>
                  </tr>
                  <tr>
                    <td>Receivable Amount (Approx.)</td>
                    <td className="right_t price_tb">
                      0.0151772 BTC
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="2" className="">
                      <small>
                        <i className="ri-information-2-line"></i> This is an internal transfer. The final disbursed amount will be based on the current market rate at the time of execution. Minor fluctuations may occur between placing the order and its execution.
                      </small>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="mt-3">
                <form>
                  <button type="button" className="swap_button " data-bs-dismiss="modal">
                    Confirm Order
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default Swap;
